module.exports = "https://r.nearpod.com/assets/media/image/npp_play_youtube-83a88b82d5d17e8505abe8cb7436d85f.svg";